module.exports = __webpack_public_path__ + "contact.3aa9383f54bbb2c71931.png";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/src/css/img/contact.png
// module id = ../../../../../src/css/img/contact.png
// module chunks = styles